<template>
  <div class="authority-manager">
    <div class="bread">
      <el-button
        size="mini"
        plain
        type="primary"
        @click="$router.go(-1)"
      >
        <i class="el-icon-arrow-left" />返回
      </el-button>
      <span style="margin-left:12px;">
        <span
          class="breadHead"
          @click="$router.go(-1)"
        >网页管理</span>
        <span style="margin:0 9px;color:#C0C4CC;font-weight:700;">/</span>权限管理
      </span>
    </div>
    <div class="layout-cont-box">
      <div
        class="user-t-title clear-fix"
      >
        <p class="user-t-p fl">
          权限管理
        </p>
        <el-button
          class="btn-plain-orange fl"
          size="small"
          @click="deletePermit"
        >
          批量删除
        </el-button>
        <el-button
          class="fl"
          type="primary"
          size="small"
          @click="addPermit"
        >
          授权对象
        </el-button>
      </div>

      <div
        v-loading="page.loading"
        class="table-cont"
      >
        <div
          v-if="tableData.length === 0 && page.loading === false"
          class="record-empty"
        >
          <img
            src="../../../assets/image/pic_null.png"
            alt=""
          >
          <p>未对任何人进行授权，请设置授权对象</p>
        </div>
        <el-table
          v-else
          border
          :data="tableData"
          header-cell-class-name="light-green"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
          />
          <template v-for="(col, idx) in tableCol">
            <el-table-column
              v-if="col.prop === 'relations'"
              :key="idx"
              :label="col.label"
              :width="col.width"
            >
              <div
                slot-scope="{row: {relations}}"
                class="auth-pri-wrap clear-fix"
              >
                <span
                  v-for="sp in relations"
                  :key="sp.key"
                  class="auth-princ fl"
                >
                  <i :class="sp.type" />
                  <span>{{ sp.name }}</span>
                </span>
              </div>
            </el-table-column>
            <el-table-column
              v-else
              :key="idx"
              :label="col.label"
              :width="col.width"
            >
              <ul
                slot-scope="{row}"
                class="cf-tabs"
              >
                <li
                  v-for="(tab, i) in row[col.prop]"
                  :key="i"
                  class="cf-tab"
                >
                  {{ tab.name }}
                </li>
              </ul>
            </el-table-column>
          </template>
          <el-table-column
            label="操作"
            width="180"
          >
            <template slot-scope="{row}">
              <mix-tooltip
                :enterable="false"
                content="修改对象"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <span
                  class="tab-handler tab-change"
                  @click="tableHandler(row, 'principal')"
                />
              </mix-tooltip>
              <mix-tooltip
                :enterable="false"
                content="修改权限"
                popper-class="user-table-tooltip weight"
                placement="top"
                effect="light"
              >
                <span
                  class="tab-handler tab-limits"
                  @click="tableHandler(row, 'limit')"
                />
              </mix-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <!--修改权限-->
    <el-dialog
      :close-on-click-modal="false"
      width="600px"
      class="narrow-padding"
      :append-to-body="true"
      :visible.sync="page.limit"
    >
      <div
        slot="title"
        class="dialog-title"
      >
        <span>授权</span>
      </div>
      <div class="r-dia-box">
        <menu-items
          v-if="page.limit"
          ref="modele"
          :promise="temp.handleRow"
        />
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          class="btn-plain"
          size="small"
          @click="page.limit = false"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :loading="page.submiting"
          size="small"
          @click="submitFormPermiss"
        >
          确认
        </el-button>
      </div>
    </el-dialog>
    <!--修改授权对象-->
    <range-selector
      v-model="page.principal"
      class="narrow-padding"
      :options="options2"
      :default-select="temp.selectTabs"
      @change="submitForm"
    />
  </div>
</template>

<script>
import api from './proxy';
import MenuItems from './MenuItems';
// import SelectPrincipal from './SelectPrincipal';
export default {
    name: 'ProjManage',
    components: { MenuItems },
    data () {
        return {
            options2: {
                title: '选择对象',
                type: 'authorizedObject',
                layout: [
                    'department',
                    'member',
                    'role',
                ],
            },
            page: {
                limit: false, // 修改权限
                submiting: false,
                loading: true,
                principal: false, // 授权对象
            },
            tableData: [
            ],
            checkedList: [],
            tableCol: [
                {
                    prop: 'relations',
                    label: '被授权对象',
                    width: '',
                },
                {
                    prop: 'actions',
                    label: '权限',
                    width: '',
                },
            ],
            temp: {
                selectTabs: [],
                permitObjectId: '',
                handleRow: [],
            },
        };
    },
    mounted () {
        this.init();
    },
    methods: {
        init () {
            this.page.loading = true;
            let params = {
                appCode: this.$store.getters['system/appCode'],
            };
            api.getList(params).then(data => {
                if (data.errcode === 0) {
                    this.tableData = data.data.list;
                } else {
                    this.$message.error(data.errmsg);
                }
                this.page.loading = false;
            }).catch(() => {
                this.page.loading = false;
            });
        },
        tableHandler (row, type) {
            Object.assign(this.temp, {
                selectTabs: row.relations,
                permitObjectId: row.permitObjectId,
                handleRow: row.actions,
            });
            switch (type) {
                case 'limit': {
                    this.page.limit = true;
                }
                    break;
                case 'principal': { // 修改对象
                    this.page.principal = true;
                }
                    break;
            }
        },
        /* 确认修改授权对象 */
        submitForm (p) {
            this.temp.selectTabs = p;
            if (p.length) {
                this.page.submiting = true;
                api.updata(JSON.stringify({
                    appCode: this.$store.getters['system/appCode'],
                    permitObjectId: this.temp.permitObjectId,
                    relations: p,
                }),
                ).then(data => {
                    if (data.errcode === 0) {
                        this.page.principal = false;
                        this.init();
                    } else {
                        this.$message.error(data.errmsg);
                    }
                    this.page.submiting = false;
                });
            } else {
                this.$message.warning('必须选择授权对象');
            }
        },
        /* 修改权限 */
        submitFormPermiss () {
            let check = this.$refs.modele.getCheckedModules(),
                permitObjectId = this.temp.permitObjectId;
            this.page.submiting = true;
            if (check.length === 0) {
                check.push({
                    permitObjectId,
                    actionId: '',
                });
            }
            api.changeAuthori({
                appCode: this.$store.getters['system/appCode'],
                relations: (check.map(itm => {
                    return {
                        permitObjectId,
                        actionId: itm.actionId,
                    };
                })),
            }).then(data => {
                if (data.errcode === 0) {
                    this.page.limit = false;
                    this.$message.success('授权成功');
                    this.init();
                } else {
                    this.$message.error(data.errmsg);
                }
                this.page.submiting = false;
            });
        },
        /* 删除权限 */
        deletePermit () {
            if (this.checkedList.length) {
                this.$confirm('确认删除？', '提示', {
                    confirmButtonText: '确定',
                    closeOnClickModal: false,
                    cancelButtonText: '取消',
                    type: 'warning',
                }).then(() => {
                    api.delete({
                        appCode: this.$store.getters['system/appCode'],
                        permitObjectIds: this.checkedList.map(itm => itm.permitObjectId),
                    }).then(data => {
                        if (data.errcode === 0) {
                            this.init();
                            // this.$message.success('')
                        } else {
                            this.$message.error(data.errmsg);
                        }
                    });
                }).catch(() => {});
            } else {
                this.$message.warning('请选择权限对象');
            }
        },
        /* 添加权限对象 */
        addPermit () {
            Object.assign(this.temp, {
                selectTabs: [],
                permitObjectId: '',
                handleRow: [],
            });
            this.page.principal = true;
        },
        /* 选中表格 */
        handleSelectionChange (data) {
            this.checkedList = data;
        },
    },
};
</script>

<style lang="scss">
  @import "../../../sass/theme.scss";
  .cf-tabs {
    text-align: center;
    margin-right: -24px;
    margin-bottom: -10px;
    .cf-tab {
      height: 26px;
      display: inline-block;
      line-height: 24px;
      padding: 0 15px;
      border-radius: 5px;
      border: 1px solid $primary;
      margin-right: 24px;
      margin-bottom: 10px;
    }
    & + .cf-tabs {
      margin-top: 10px;
    }
  }
  .user-table-tooltip.el-tooltip__popper.weight.is-light {
        border-color: $primary;
        .popper__arrow {
            border-top-color: $primary;
        }
    }
  .authority-manager {
    .cell {
        display: flex;
        justify-content: center;
    }
    .tab-handler {
        color: $primary;
        cursor: pointer;
        display: inline-block;
        height: 30px;
        min-width: 30px;
        margin-right: 10px;
    }
    .bread {
        height: 56px;
        line-height: 56px;
        .breadHead {
            font-weight: 700;
            cursor: pointer;
            &:hover {
                color: #2ED095;
            }
        }
    }
    .layout-cont-box {
      min-height: 180px;
    }
    .tab-handler {
      &.tab-change {
        background: url("../../../assets/icon/icon_form_object_grey.png") no-repeat center;
        &:hover {
          background-image: url('../../../assets/icon/icon_form_object_green.png');
        }
      }
      &.tab-limits {
        background: url("../../../assets/icon/icon_form_jurisdiction_grey.png") no-repeat center;
        &:hover {
          background-image: url('../../../assets/icon/icon_form_jurisdiction_green.png');
        }
      }
    }

    .r-dia-box {
      margin-top: -15px;
    }
    .auth-pri-wrap {
      margin-right: -12px;
      margin-bottom: -12px;
    }
    .auth-princ {
      margin-right: 12px;
      margin-bottom: 12px;
      border-radius: 5px;
      padding: 5px 10px 5px 0;
      background: $light-primary;
      white-space: nowrap;
      .member {
        padding: 0 15px;
        background: url("../../../assets/icon/icon_elastic_role_green.png") no-repeat center center;
      }
      .department {
        padding: 0 15px;
        background: url("../../../assets/icon/icon_elastic_department_green.png") no-repeat center center;
      }
      .role {
        padding: 0 15px;
        background: url("../../../assets/icon/icon_elastic_role_group_green.png") no-repeat center center;
      }
    }
    .el-button {
      margin-top: 10px;
    }
    .user-t-p {
      margin-right: 10px;
    }
    .dialog-footer {
      margin-top: -25px;
    }
    .table-cont {
      padding: 15px 24px 0;
      position: relative;
      padding-bottom: 15px;
      min-height: 400px;
    }
    .record-empty {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      height: 400px;
      position: relative;
    }
  }
</style>
